var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMarkButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A9CF3D"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.602.189C4.308.189 0 4.497 0 9.79c0 5.295 4.308 9.602 9.602 9.602 5.294 0 9.602-4.307 9.602-9.602 0-5.294-4.308-9.602-9.602-9.602zm0 17.656c-4.44 0-8.055-3.613-8.055-8.054 0-4.442 3.615-8.055 8.055-8.055 4.441 0 8.054 3.614 8.054 8.055 0 4.44-3.613 8.054-8.054 8.054z",
    transform: "translate(-295 -537) translate(255 185) translate(40 350) translate(0 2.65)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.663 6.729L8.18 11.212l-1.64-1.641c-.302-.302-.792-.302-1.093 0-.303.303-.303.793 0 1.094l2.186 2.188c.152.15.349.226.547.226.197 0 .396-.076.548-.226l5.028-5.03c.303-.303.303-.791 0-1.094-.301-.301-.791-.301-1.094 0z",
    transform: "translate(-295 -537) translate(255 185) translate(40 350) translate(0 2.65)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkButton);
export default __webpack_public_path__ + "static/media/check-mark-button.68e9d33bedb46226d207f9da97c4d3e8.svg";
export { ForwardRef as ReactComponent };